import { Component, OnInit } from '@angular/core';
import { LayoutService } from 'app/shared/services/layout.service';
import { MatDialog } from '@angular/material/dialog';
import { AppInfoService } from 'app/shared/services/app-info.service';
import { AboutDialogComponent } from '../about-dialog/about-dialog.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public layoutConf: any;
  public backendBuild: string | null = null;

  constructor(
    private layout: LayoutService,
    public appInfo: AppInfoService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.layoutConf = this.layout.layoutConf;
    // Best-effort: build do backend (não bloqueia nem quebra se offline)
    this.appInfo.getBackendBuildTime().subscribe(build => this.backendBuild = build);
  }

  openAbout() {
    this.dialog.open(AboutDialogComponent, { autoFocus: false });
  }

}
